<template>
  <div class="factoid bg-primary-tint-6 py-8 md:py-12 lg:py-16 px-6 sm:px-8">
    <div
      class="centered-content max-w-7xl mx-auto flex items-start justify-center"
    >
      <div
        v-if="factoid"
        class="facts flex flex-col items-start sm:flex-row md:items-start"
      >
        <LightBulb
          class="lightbulb flex-shrink-0 mb-8 sm:mr-10"
          style="height: 80px; width: 80px"
        />

        <div class="fact-text-block max-w-4xl">
          <TypeOverline
            :variant="Typography.Overline.LARGE"
            :weight="Typography.Weights.STRONG"
            tag="p"
            class="text-primary leading-normal mb-6"
          >
            Did you know?
          </TypeOverline>
          <TypeDisplay
            :variant="Typography.Display.MEGA"
            :weight="Typography.Weights.REGULAR"
            tag="p"
            class="text-black leading-normal"
          >
            {{ factoid }}
          </TypeDisplay>
        </div>
      </div>
      <div v-if="quote" class="quote">
        <Quote class="open-quote mb-2" />
        <TypeDisplay
          :variant="Typography.Display.MEGA"
          :weight="Typography.Weights.REGULAR"
          tag="p"
          class="text-black leading-normal"
        >
          {{ quote }}
        </TypeDisplay>
        <Quote class="close-quote block mb-3 ml-auto transform rotate-180" />
        <div class="avatar-container flex justify-end">
          <UserAvatar
            :image="image"
            :name="fullname"
            :title="title"
            size="large"
            class="user-avatar"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  constants,
  TypeDisplay,
  TypeOverline,
  UserAvatar,
} from '@bambeehr/pollen';
import LightBulb from '~/assets/images/market/icons/hl-icon-lightbulb.svg';
import Quote from '~/assets/images/market/icons/quote.svg';
const { Typography } = constants;
export default {
  name: 'Factoid',
  components: {
    LightBulb,
    Quote,
    TypeDisplay,
    TypeOverline,
    UserAvatar,
  },
  props: {
    factoid: {
      type: String,
      default: null,
    },
    quote: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    fullname: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      Typography,
    };
  },
};
</script>

<style scoped>
.user-avatar >>> .avatar-image {
  @apply w-16 h-16 !important;
}
.user-avatar >>> .user-avatar__name {
  @apply text-primary text-19 font-semibold;
}
.user-avatar >>> .user-avatar__title {
  @apply text-16 text-gray-3 font-medium !important;
}
</style>
